var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 44,
    viewBox: "0 0 58 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1052 43.2587V20.9797L6.19582 14.6586L0 11.1509V39.327C0 41.5024 1.76254 43.2587 3.93166 43.2587H13.1052Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5568 43.2585H53.7303C55.906 43.2585 57.662 41.4957 57.662 39.3268V11.1509L50.6442 15.1686L44.5568 20.9795V43.2585Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1061 20.9795L12.1659 12.2745L13.1061 3.94287L28.8322 15.7376L44.5584 3.94287L45.6101 11.8247L44.5584 20.9795L28.8322 32.7743L13.1061 20.9795Z",
    fill: "#EA4335"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5568 3.94262V20.9793L57.662 11.1505V5.90834C57.662 1.04642 52.1119 -1.72522 48.2265 1.19058L44.5568 3.94262Z",
    fill: "#FBBC04"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.1506L6.02734 15.6712L13.1052 20.9794V3.94273L9.43552 1.19068C5.54328 -1.72534 0 1.04652 0 5.90822V11.1506Z",
    fill: "#C5221F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.7c4998e9ba2084343db8ccfaae4d5731.svg";
export { ForwardRef as ReactComponent };